import React from 'react'
import { motion } from 'framer-motion'
import { Cpu, Zap, Shield, Image as ImageIcon, Rocket, Layers } from 'lucide-react'

export default function Features() {
  return (
    <section className="py-24 bg-black relative overflow-hidden">
      {/* Grid Background */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:40px_40px] opacity-20"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl md:text-5xl font-black text-white mb-4"
          >
            PODER BRUTO <span className="text-cyber-blue">LOCAL</span>
          </motion.h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg">
            Projetado para extrair cada gota de performance do seu hardware.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          <FeatureCard 
            icon={<Cpu className="w-8 h-8 text-cyber-blue" />}
            title="Aceleração via GPU"
            description="Utiliza os núcleos CUDA da sua placa de vídeo NVIDIA ou AMD para processamento ultra-rápido."
          />
          <FeatureCard 
            icon={<Zap className="w-8 h-8 text-yellow-400" />}
            title="Sem Limites"
            description="Processe 10, 100 ou 1000 imagens por dia. Você é dono do hardware, você define o limite."
          />
          <FeatureCard 
            icon={<Shield className="w-8 h-8 text-green-400" />}
            title="Privacidade Total"
            description="Suas imagens nunca saem do seu computador. Ideal para projetos confidenciais e NDA."
          />
          <FeatureCard 
            icon={<ImageIcon className="w-8 h-8 text-purple-400" />}
            title="Upscale até 8x"
            description="Aumente a resolução das suas imagens em até 8 vezes com recuperação de detalhes incrível."
          />
          <FeatureCard 
            icon={<Rocket className="w-8 h-8 text-red-400" />}
            title="Batch Processing"
            description="Coloque pastas inteiras para processar e vá tomar um café. O software cuida do resto."
          />
          <FeatureCard 
            icon={<Layers className="w-8 h-8 text-cyan-400" />}
            title="Modelos Offline"
            description="Baixe os modelos de IA uma vez e use para sempre, mesmo sem conexão com a internet."
          />
        </div>
      </div>
    </section>
  )
}

const FeatureCard = ({ icon, title, description }: { icon: React.ReactNode, title: string, description: string }) => (
  <motion.div 
    whileHover={{ y: -5 }}
    className="p-8 rounded-2xl bg-white/5 border border-white/10 hover:border-cyber-blue/30 transition-colors group"
  >
    <div className="mb-6 p-4 rounded-xl bg-black/50 w-fit border border-white/5 group-hover:border-cyber-blue/20 transition-colors">
      {icon}
    </div>
    <h3 className="text-xl font-bold text-white mb-3 group-hover:text-cyber-blue transition-colors">{title}</h3>
    <p className="text-gray-400 leading-relaxed text-sm">
      {description}
    </p>
  </motion.div>
)
